/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Færdig med at redigere',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Foretag redigeringer',
  'editor-common-extensibility.macro.button.configure': 'Konfigurer {macroName}',
  'editor.extension.legacyContentHeader': 'Ældre indhold',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Dette indhold har begrænset funktionalitet.',
  'editor.extension.legacyContentHeader.learnMore': 'Få mere at vide',
  'fablric.editor.viewAllInserts': 'Se alt, der kan indsættes',
  'fabric.editor.action': 'Handlingsgenstand',
  'fabric.editor.action.description': 'Opret og tildel handlingsgenstande',
  'fabric.editor.addAltText': 'Alternativ tekst',
  'fabric.editor.addColumnLeft': 'Tilføj kolonne til venstre',
  'fabric.editor.addColumnRight': 'Tilføj kolonne til højre',
  'fabric.editor.addCommentOnMedia': 'Tilføj kommentar',
  'fabric.editor.addImageBorder': 'Tilføj kant',
  'fabric.editor.addLoomVideo': 'Optag en Loom-video',
  'fabric.editor.addLoomVideoComment': 'Optag en Loom-videokommentar',
  'fabric.editor.addMediaFiles': 'Tilføj billede, video eller fil',
  'fabric.editor.addRowAbove': 'Tilføj række ovenfor',
  'fabric.editor.addRowBelow': 'Tilføj række nedenfor',
  'fabric.editor.addUpdatedAltText': 'Tilføj alternativ tekst',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Brug Atlassian Intelligence til at finde handlingspunkter og vise dem i et panel',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Handlingspunktpanel (Beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Brug Atlassian Intelligence til at opsummere denne side og vise den i et panel',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Sideoversigtspanel (Beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Valgt indhold',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Genererer indhold, der skal sættes ind i opdateringen',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Opsummerer opdateringens indhold',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generér',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Spørg Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Rediger',
  'fabric.editor.ai.config.item.action.insert': 'Indsæt',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Indsæt foroven',
  'fabric.editor.ai.config.item.action.insertBelow': 'Indsæt nedenfor',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Indsæt under original',
  'fabric.editor.ai.config.item.action.replace': 'Erstat',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Erstat titel',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Titlen må højst indeholde {maxLength} tegn',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Fortsæt i chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Åbn i chat',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo-medarbejder',
  'fabric.editor.ai.config.item.atlas-shorten-update.description':
    'Forkorter indholdet for at gøre det mere kortfattet',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Forkort opdateringen',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Opretter en beskrivelse af pullanmodningen med en oversigt over ændringer',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Opret beskrivelse af pullanmodning',
  'fabric.editor.ai.config.item.brainstorm.description': 'Genererer en liste over idéer til et emne, du angiver',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Fortæl mig emnet …',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorm',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorm',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Længde',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Juster længden',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Ændrer tonen i indholdet til afslappet',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Afslappet',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Afslappet',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Skift tone til uformel',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Ændrer tonen i indholdet til pædagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Pædagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Pædagogisk',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Skift tone til pædagogisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Ændrer tonen i indholdet til empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatisk',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Skift tone til empatisk',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Skift tone til ...',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Ændrer tonen i indholdet til neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Skift tone til neutral',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Ændrer tonen i indholdet til professionel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Skift tone til professionel',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Omdanner indholdet til en liste med punktopstilling',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Omdan til punktopstillet liste',
  'fabric.editor.ai.config.item.convertToTable.description': 'Omformaterer indhold til en tabel med overskrifter',
  'fabric.editor.ai.config.item.convertToTable.title': 'Omdan til tabel',
  'fabric.editor.ai.config.item.draftReply.description':
    'Udarbejder et udkast til svar baseret på sager, der ligner den, du arbejder på',
  'fabric.editor.ai.config.item.draftReply.title': 'Lav udkast til svar',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Retter stave- og grammatikfejl',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Stavning og grammatik',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Ret stavning og grammatik',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Forbedrer klarhed, struktur og tone for at gøre teksten mere interessant og lettere at forstå',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Gør teksterne bedre',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Gør teksterne bedre',
  'fabric.editor.ai.config.item.findActionItems.description': 'Finder handlingselementer i det indhold, du leverer',
  'fabric.editor.ai.config.item.findActionItems.title': 'Find handlingspunkter',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Vælg mellem nedenstående (fri generering er deaktiveret i Elevate i øjeblikket)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Skriv med AI, eller vælg en af mulighederne herunder',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Omstrukturer sagsbeskrivelsen baseret på sagstypen',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Forbedr beskrivelsen',
  'fabric.editor.ai.config.item.makeLonger.description': 'Udvider indholdet baseret på den kontekst, du angiver',
  'fabric.editor.ai.config.item.makeLonger.title': 'Gør længere',
  'fabric.editor.ai.config.item.range.agent.description': 'Ingen beskrivelse',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Bed agenten om at skrive noget, eller vælg fra listen nedenfor',
  'fabric.editor.ai.config.item.rephrase.description': 'Opretter et forslag til omskrivning af dine sætninger',
  'fabric.editor.ai.config.item.rephrase.title': 'Omformuler',
  'fabric.editor.ai.config.item.shorten.description': 'Forkorter indholdet for at gøre det mere kortfattet',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Gør kortere',
  'fabric.editor.ai.config.item.shorten.title': 'Gør kortere',
  'fabric.editor.ai.config.item.suggest.description': 'Foreslår en titel til indhold, du leverer',
  'fabric.editor.ai.config.item.suggest.title': 'Foreslå en titel',
  'fabric.editor.ai.config.item.summarize.description':
    'Opretter en oversigt over den tekst, du arbejder på, og fremhæver nøglepunkter',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Opsummer markeret tekst',
  'fabric.editor.ai.config.item.summarize.title': 'Opsummer markeret tekst',
  'fabric.editor.ai.config.item.translate.czech': 'Tjekkisk',
  'fabric.editor.ai.config.item.translate.danish': 'Dansk',
  'fabric.editor.ai.config.item.translate.dutch': 'Hollandsk',
  'fabric.editor.ai.config.item.translate.english': 'Engelsk',
  'fabric.editor.ai.config.item.translate.finnish': 'Finsk',
  'fabric.editor.ai.config.item.translate.french': 'Fransk',
  'fabric.editor.ai.config.item.translate.german': 'Tysk',
  'fabric.editor.ai.config.item.translate.hungarian': 'Ungarsk',
  'fabric.editor.ai.config.item.translate.italian': 'Italiensk',
  'fabric.editor.ai.config.item.translate.japanese': 'Japansk',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Oversæt',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Oversæt til ...',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norsk',
  'fabric.editor.ai.config.item.translate.russian': 'Russisk',
  'fabric.editor.ai.config.item.translate.spanish': 'Spansk',
  'fabric.editor.ai.config.item.translate.swedish': 'Svensk',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Oversætter den tekst, du arbejder på, til kinesisk (forenklet)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Oversæt til kinesisk (forenklet)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Oversætter den tekst, du arbejder på, til kinesisk (traditionelt)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Oversæt til kinesisk (traditionelt)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Oversætter den tekst, du arbejder på, til tjekkisk',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Oversæt til tjekkisk',
  'fabric.editor.ai.config.item.translateTo.danish.description': 'Oversætter den tekst, du arbejder på, til dansk',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Oversæt til dansk',
  'fabric.editor.ai.config.item.translateTo.dutch.description': 'Oversætter den tekst, du arbejder på, til hollandsk',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Oversæt til hollandsk',
  'fabric.editor.ai.config.item.translateTo.english.description': 'Oversætter den tekst, du arbejder på, til engelsk',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Oversæt til engelsk',
  'fabric.editor.ai.config.item.translateTo.finnish.description': 'Oversætter den tekst, du arbejder på, til finsk',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Oversæt til finsk',
  'fabric.editor.ai.config.item.translateTo.french.description': 'Oversætter den tekst, du arbejder på, til fransk',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Oversæt til fransk',
  'fabric.editor.ai.config.item.translateTo.german.description': 'Oversætter den tekst, du arbejder på, til tysk',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Oversæt til tysk',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': 'Oversætter den tekst, du arbejder på, til ungarsk',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Oversæt til ungarsk',
  'fabric.editor.ai.config.item.translateTo.italian.description': 'Oversætter den tekst, du arbejder på, til italiensk',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Oversæt til italiensk',
  'fabric.editor.ai.config.item.translateTo.japanese.description': 'Oversætter den tekst, du arbejder på, til japansk',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Oversæt til japansk',
  'fabric.editor.ai.config.item.translateTo.korean.description': 'Oversætter den tekst, du arbejder på, til koreansk',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Oversæt til koreansk',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': 'Oversætter den tekst, du arbejder på, til norsk',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Oversæt til norsk',
  'fabric.editor.ai.config.item.translateTo.polish.description': 'Oversætter den tekst, du arbejder på, til polsk',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Oversæt til polsk',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Oversætter den tekst, du arbejder på, til portugisisk (brasiliansk)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Oversæt til portugisisk (brasiliansk)',
  'fabric.editor.ai.config.item.translateTo.russian.description': 'Oversætter den tekst, du arbejder på, til russisk',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Oversæt til russisk',
  'fabric.editor.ai.config.item.translateTo.spanish.description': 'Oversætter den tekst, du arbejder på, til spansk',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Oversæt til spansk',
  'fabric.editor.ai.config.item.translateTo.swedish.description': 'Oversætter den tekst, du arbejder på, til svensk',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Oversæt til svensk',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Oversætter den tekst, du arbejder på, til thai',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Oversæt til thai',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Oversætter den tekst, du arbejder på, til tyrkisk',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Oversæt til tyrkisk',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Oversætter den tekst, du arbejder på, til ukrainsk',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Oversæt til ukrainsk',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Oversætter den tekst, du arbejder på, til vietnamesisk',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Oversæt til vietnamesisk',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Skift tone',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Omskriv',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Oversæt',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Sidetitel',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Side',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vi har problemer med at indsætte svaret. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Vi har problemer med at danne forhåndsvisningen. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Atlassian Intelligence (AI) har modtaget for mange nylige anmodninger. Prøv igen om et par minutter, eller læs om <link>overdreven brug af AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Vi kunne ikke få et svar. Prompten eller svaret var over grænsen for denne anmodning. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage': 'Vi har problemer. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience.apiError': 'Vi kunne ikke få svar. Prøv igen.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Din prompt eller dit indhold overholder muligvis ikke vores politik for acceptabel brug. Gennemgå begge dele, og se vores <link>politik for acceptabel brug</link>, hvis det er nødvendigt. Hvis problemet fortsætter, kan du overveje at prøve en anden prompt eller et andet indhold.',
  'fabric.editor.ai.experience.browseMore.agents': 'Gennemse agenter',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Vil du kassere din prompt?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Vil du kassere dit svar?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': 'Fri generering er deaktiveret i Elevate i øjeblikket.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Nu kan du indsætte links 🔗 til Jira- og Confluence-indhold i dine prompter.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Drevet af Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Genererer',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence kunne ikke behandle din anmodning, da dit indhold indeholder links til HIPAA-begrænset indhold. Fjern disse links, og prøv igen.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Indholdet er for kort til at opsummere. Tilføj mere, og prøv igen.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) svarer ikke. Prøv igen senere, eller <link>kontrollér status for AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Genererer',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyserer: Gennemgår dit spørgsmål.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Søger: Et øjeblik, mens vi søger efter informationer.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Søger: Et øjeblik, mens vi søger i Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Søger: Et øjeblik, mens vi søger på siden.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Ingen resultater',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence har ingen forslag på dette tidspunkt. Prøv en anden prompt eller andet indhold.',
  'fabric.editor.ai.experience.showMoreButton': 'Vis flere',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Handlinger',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenter',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Videnskilde',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-medarbejdere',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-medarbejdere ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount':
    'Brug en Rovo-medarbejder ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Brug generel viden',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Brug viden fra din organisation',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Vi har problemer med at danne forhåndsvisningen. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage': 'Vi har problemer. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Indsæt nedenfor',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Erstat',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Anmodninger om indholdsgenerering, der henviser til webadresser, er i beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Fremhæv et udtryk, akronym eller en forkortelse',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definer',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.askAI.title': 'Spørg AI',
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Spørg Rovo AI',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Gør teksterne bedre',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Bed Atlassian Intelligence om at forbedre den markerede tekst',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Prøv AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Åbn Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Spørg AI {key}+'",
  'fabric.editor.alignCenter': 'Centrér',
  'fabric.editor.alignImageCenter': 'Centrér',
  'fabric.editor.alignImageLeft': 'Venstrejustér',
  'fabric.editor.alignImageRight': 'Højrejustér',
  'fabric.editor.alignLeft': 'Venstrejustér',
  'fabric.editor.alignRight': 'Højrejustér',
  'fabric.editor.alignTableCenter': 'Centrér',
  'fabric.editor.alignTableLeft': 'Venstrejustér',
  'fabric.editor.alignment': 'Tekstjustering',
  'fabric.editor.altText': 'Al tekst',
  'fabric.editor.alttext.validation': 'Fjern alle specialtegn i ALT-tekst.',
  'fabric.editor.annotationToolbar': 'Værktøjslinje til annotationer',
  'fabric.editor.backLink': 'Gå tilbage',
  'fabric.editor.backgroundColor': 'Baggrundsfarve',
  'fabric.editor.blockCardUnavailable': 'Det indbyggede link er inden i {node}, og dets visning kan ikke ændres',
  'fabric.editor.blockControlDelete': 'Slet',
  'fabric.editor.blockControlDragHandleMove': 'Træk for at flytte',
  'fabric.editor.blockControlDragHandleRearrange': 'Træk for at omarrangere',
  'fabric.editor.blockControlInsert': 'Indsæt',
  'fabric.editor.blockControlMoveDown': 'Flyt ned',
  'fabric.editor.blockControlMoveLeft': 'Flyt til venstre',
  'fabric.editor.blockControlMoveRight': 'Flyt til højre',
  'fabric.editor.blockControlMoveUp': 'Flyt op',
  'fabric.editor.blockControlMovedDown': 'Indhold er flyttet ned',
  'fabric.editor.blockControlMovedUp': 'Indhold er flyttet op',
  'fabric.editor.blockDescription': 'Vis flere oplysninger om et link, inklusive sammendrag og handlinger',
  'fabric.editor.blockTitle': 'Kort',
  'fabric.editor.blockquote': 'et citat',
  'fabric.editor.blockquote.description': 'Indsæt citat',
  'fabric.editor.blockquote2': 'Citer',
  'fabric.editor.bold': 'Fed',
  'fabric.editor.breakout.resizeCodeBlock': 'Tilpas størrelse på kodestykke',
  'fabric.editor.breakout.resizeElement': 'Tilpas størrelse på element',
  'fabric.editor.breakout.resizeExpand': 'Tilpas størrelse på udvidelse',
  'fabric.editor.breakout.resizeLayout': 'Tilpas størrelse på layout',
  'fabric.editor.breakoutFullWidthLabel': 'Fuld bredde',
  'fabric.editor.breakoutWideWidthLabel': 'Bredt',
  'fabric.editor.bug': 'Fejl',
  'fabric.editor.canNotSortTable': '⚠️ En tabel med flettede celler kan ikke sorteres',
  'fabric.editor.cancelButton': 'Annullér',
  'fabric.editor.captionPlaceholder': 'Tilføj en billedtekst',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Tilføj en billedtekst – dobbeltklik for forhåndsvisning',
  'fabric.editor.cardFloatingControls': 'Muligheder for kort',
  'fabric.editor.cellBackground': 'Baggrundsfarve i celle',
  'fabric.editor.cellOptions': 'Egenskaber for celle',
  'fabric.editor.checkUncheckActionItem': 'Slå handlingselement til/fra',
  'fabric.editor.clearAltTextEdit': 'Ryd alternativ tekst',
  'fabric.editor.clearCells': '{0, plural, one {Ryd celle} other {Ryd celler}}',
  'fabric.editor.clearFormatting': 'Ryd fomattering',
  'fabric.editor.clearLink': 'Ryd link',
  'fabric.editor.clearLinkText': 'Ryd tekst',
  'fabric.editor.closeAltTextEdit': 'Tilbage',
  'fabric.editor.closeFindReplaceDialog': 'Luk',
  'fabric.editor.closeHelpDialog': 'Luk dialogboksen',
  'fabric.editor.code': 'Kode',
  'fabric.editor.code.on': '{textFormattingOff}, kode aktiveret',
  'fabric.editor.codeBidiWarningLabel':
    'Tegn med tovejsfunktionalitet ændrer rækkefølgen, som teksten er gengivet i. Dette kan udnyttes til at skjule skadelig kode.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Kopieret!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopiér som tekst',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Slå ombrydning fra',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Slå ombrydning til',
  'fabric.editor.codeblock': 'Kodestump',
  'fabric.editor.codeblock.description': 'Vis kode med syntaksfremhævning',
  'fabric.editor.collapseNode': 'skjul indhold',
  'fabric.editor.collapseTable': 'Luk tabel',
  'fabric.editor.colorPicker.menuLabel': 'Farvevælgermenu',
  'fabric.editor.columnDragHandle': 'Kolonneindstillinger',
  'fabric.editor.columnMovedLeft': 'Kolonne flyttet til venstre til {index} af {total}',
  'fabric.editor.columnMovedRight': 'Kolonne flyttet til højre til {index} af {total}',
  'fabric.editor.columnSelected': 'Kolonne {index} af {total} er valgt',
  'fabric.editor.columns': 'Layout',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Indsæt {numberOfColumns} lige kolonne} other {Indsæt {numberOfColumns} lige kolonner}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Indsæt et layout med en enkelt kolonne',
  'fabric.editor.columns.description': 'Opdel din side i afsnit',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {En kolonne er blevet indsat} other {{count} kolonner er blevet indsat}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Kolonnen er blevet fjernet} other {{count} kolonner er blevet fjernet}}',
  'fabric.editor.configFailedToLoad': 'Kunne ikke indlæses',
  'fabric.editor.configPanel.cancel': 'Annuller',
  'fabric.editor.configPanel.close': 'Luk',
  'fabric.editor.configPanel.customSelect.createOption': 'Opret',
  'fabric.editor.configPanel.dateRange.custom.from': 'Fra',
  'fabric.editor.configPanel.dateRange.custom.to': 'Til',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Skjul',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Udvid',
  'fabric.editor.configPanel.dateRange.option.custom': 'Brugerdefineret',
  'fabric.editor.configPanel.documentation': 'Dokumentation',
  'fabric.editor.configPanel.errorBoundary.note':
    'Vi har fortalt teamet det. Du kan stadig redigere og udgive denne side eller tjekke fejlkonsollen for at få flere oplysninger.',
  'fabric.editor.configPanel.errorBoundary.title': 'Noget gik galt.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio':
    'Kunne ikke kombinere isMultiple med stilen: alternativknap',
  'fabric.editor.configPanel.formType.addField': 'Tilføj felt',
  'fabric.editor.configPanel.formType.removeField': 'Fjern felt',
  'fabric.editor.configPanel.help': 'Har du brug for hjælp?',
  'fabric.editor.configPanel.invalid': 'Ugyldigt felt',
  'fabric.editor.configPanel.required': 'Påkrævet felt',
  'fabric.editor.configPanel.submit': 'Send',
  'fabric.editor.contextPanel.panelLabel': 'Kontekstpanel',
  'fabric.editor.copiedToClipboard': 'Kopieret!',
  'fabric.editor.copyToClipboard': 'Kopiér',
  'fabric.editor.cornerControl': 'Fremhæv tabel',
  'fabric.editor.createComment': 'Kommenter',
  'fabric.editor.createCommentDisabled':
    'Du kan kun kommentere tekst, overskrifter, emojier, datoer, omtaler, links og statusser.',
  'fabric.editor.createCommentInvalid': 'Du kan kun kommentere tekst og overskrifter',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Forstået',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Nu kan du oprette kommentarer til indlejrede elementer som links, datoer, statusser og omtaler.',
  'fabric.editor.customPanel': 'Brugerdefineret panel',
  'fabric.editor.customPanel.description': 'Tilføj en note med en emoji og farvet baggrund',
  'fabric.editor.datasource.assetsObjects.description':
    'Indsæt objekter fra Aktiver i Jira Service Management med søgning og filtrering',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Aktiver',
  'fabric.editor.datasource.confluenceSearch': 'Indsæt Confluence-liste',
  'fabric.editor.datasource.confluenceSearch.description':
    'Indsæt liste over søgeresultater fra Confluence med forbedret søgning, filtrering og konfiguration.',
  'fabric.editor.datasource.jiraIssue': 'Jira-sager',
  'fabric.editor.datasource.jiraIssue.description':
    'Indsæt Jira-sager fra Jira Cloud med forbedret søgning, filtrering og konfiguration.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Indsæt Jira-sager fra Jira Cloud med forbedret søgning, filtrering og konfiguration.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-sager',
  'fabric.editor.datasourceAppearanceTitle': 'Liste',
  'fabric.editor.datasourceTitle': 'Rediger søgning',
  'fabric.editor.date': 'Dato',
  'fabric.editor.date.description': 'Tilføj en dato med en kalender',
  'fabric.editor.datePickerOpenedAlert':
    'Pop op-vinduet til datoredigering er åbnet. Tryk på Tabulatorknappen for at få adgang til pop op-vinduet',
  'fabric.editor.decision': 'Beslutning',
  'fabric.editor.decision.description': 'Registrér beslutninger, så de er lette at finde igen',
  'fabric.editor.decisionPlaceholder': 'Tilføj en beslutning ...',
  'fabric.editor.decreaseElementSize': 'Reducer elementstørrelse',
  'fabric.editor.decreaseSize': 'Reducer tabel- eller mediestørrelse',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Slet',
  'fabric.editor.description': 'Beskrivelse',
  'fabric.editor.displayBlock': 'Vis som kort',
  'fabric.editor.displayEmbed': 'Vis som indlejret',
  'fabric.editor.displayInline': 'Vis indbygget',
  'fabric.editor.displayLink': 'Vis som tekst',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Denne visningsmulighed er ikke tilgængelig i {node}',
  'fabric.editor.displayText': 'Vist tekst',
  'fabric.editor.distributeColumns': 'Fordel kolonner',
  'fabric.editor.dragHandleZone': 'Aktivér trækhåndtagszonen',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Vis en interaktiv forhåndsvisning af et link',
  'fabric.editor.edit': 'Redigér',
  'fabric.editor.edit.datasource': 'Rediger søgning',
  'fabric.editor.edit.searchInput': 'Tilføj et link',
  'fabric.editor.editAccessTitle': 'Du skal have redigeringsadgang',
  'fabric.editor.editAltText': 'Rediger alternativ tekst',
  'fabric.editor.editDatasourceStandalone': 'Rediger',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Rediger søgning',
  'fabric.editor.editDateText': 'Rediger dato',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Rediger søgning',
  'fabric.editor.editDropdownEditLinkTitle': 'Rediger link',
  'fabric.editor.editDropdownExpandIconLabel': 'Udvid rullemenu',
  'fabric.editor.editDropdownTriggerTitle': 'Rediger',
  'fabric.editor.editLink': 'Redigér link',
  'fabric.editor.editMode.inviteToEditButton.title': 'Invitér til at redigere',
  'fabric.editor.editStatusColor': 'Rediger statusfarve',
  'fabric.editor.editStatusText': 'Rediger status',
  'fabric.editor.editableContentLabel': 'Redigerbart indhold',
  'fabric.editor.editorHelp': 'Hjælp til redigering',
  'fabric.editor.editors': 'Redaktører',
  'fabric.editor.elementBrowser.help': 'Hjælp',
  'fabric.editor.elementInsertSidePanel.title': 'Indsæt',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Alle',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Kommunikation',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence-indhold',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Udvikling',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Eksternt indhold',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatering',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Medie',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigation',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapportering',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Grafik og billeder',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Brug et whiteboard til at føje billeder til din side',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Ingen resultater matcher din søgning',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Prøv et andet søgeord, eller find nye apps til Atlassian-produkter.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Gå på opdagelse på Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Der er ikke noget, der matcher din søgning.} one {{count} forslag er tilgængeligt som standard.} other {{count} forslag er tilgængelige som standard.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Der er ikke noget, der matcher din søgning.} one {{count} muligt forslag til indtastet tekst.} other {{count} mulige forslag til indtastet tekst.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Indtast',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Søg',
  'fabric.editor.elementbrowser.sidebar.heading': 'Gennemse',
  'fabric.editor.embedTitle': 'Indlejr',
  'fabric.editor.embedToBlockCardWarning': 'Vises som et kort på små skærme',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Brug humørikoner for at udtrykke idéer 🎉 og følelser 😄',
  'fabric.editor.emptyLink': 'Indtast et link.',
  'fabric.editor.emptySearchResults': 'Vi kunne ikke finde nogen resultater.',
  'fabric.editor.emptySearchResultsSuggestion': 'Vælg {buttonName} for at gennemse indsættelser.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Fejl',
  'fabric.editor.errorPanel': 'Fejlpanel',
  'fabric.editor.errorPanel.description': 'Vis fejl i et farvel panel',
  'fabric.editor.expand': 'Udvid',
  'fabric.editor.expand.description': 'Indsæt en udvidelse',
  'fabric.editor.expandAriaLabel': 'Giv denne udvidelse en titel',
  'fabric.editor.expandDefaultTitle': 'Klik her for at udvide...',
  'fabric.editor.expandNode': 'Udvid indhold',
  'fabric.editor.expandPlaceholder': 'Giv denne udvidelse en titel...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Hvis du sletter {nodeName}, brydes forbindelsen til alt, der er forbundet til den.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Sletter',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Slet',
  'fabric.editor.extension.deleteElementTitle': 'Slet element',
  'fabric.editor.extension.sourceNoTitledName': 'dette element',
  'fabric.editor.extensions.config-panel.save-indicator': 'Alle ændringer gemmes altid automatisk',
  'fabric.editor.externalExtensionsHeading': 'Apps',
  'fabric.editor.externalMediaFile': 'Ekstern mediefil',
  'fabric.editor.failed_to_upload': 'Upload mislykkedes',
  'fabric.editor.feedbackDialog': 'Giv feedback',
  'fabric.editor.feedbackDialog.description': 'Fortæl os om din oplevelse med skyeditoren',
  'fabric.editor.find': 'Find',
  'fabric.editor.findNext': 'Find næste',
  'fabric.editor.findPrevious': 'Find forrige',
  'fabric.editor.findReplaceToolbarButton': 'Find og erstat',
  'fabric.editor.fiveColumns': 'Layout med fem kolonner',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Annuller',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Slet også forbundne elementer',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 forbundet element)} other {{name} (+{amount,number} forbundne elementer)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Er du sikker?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Flydende værktøjslinje er blevet åbnet',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Flydende værktøjslinje',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layoutindstillinger',
  'fabric.editor.floatingToolbar.scrollLeft': 'Rul til venstre',
  'fabric.editor.floatingToolbar.scrollRight': 'Rul til højre',
  'fabric.editor.focusTableResizeHandle': 'Håndtag til ændring af størrelse på tabel i fokus',
  'fabric.editor.fourColumns': 'Layout med fire kolonner',
  'fabric.editor.headerColumn': 'Overskriftskolonne',
  'fabric.editor.headerRow': 'Overskriftsrække',
  'fabric.editor.heading1': 'Overskrift 1',
  'fabric.editor.heading1Description': 'Brug denne til overskrift på øverste niveau',
  'fabric.editor.heading2': 'Overskrift 2',
  'fabric.editor.heading2Description': 'Brug denne til hovedafsnit',
  'fabric.editor.heading3': 'Overskrift 3',
  'fabric.editor.heading3Description': 'Brug denne til underafsnit og mindre overskrifter',
  'fabric.editor.heading4': 'Overskrift 4',
  'fabric.editor.heading4Description': 'Brug denne til dybe overskrifter',
  'fabric.editor.heading5': 'Overskrift 5',
  'fabric.editor.heading5Description': 'Brug denne til at gruppere listeelementer',
  'fabric.editor.heading6': 'Overskrift 6',
  'fabric.editor.heading6Description': 'Brug denne til overskrift på lavt niveau',
  'fabric.editor.headingLink.ascOrderLabel': 'Sortér kolonnen fra Å til A',
  'fabric.editor.headingLink.descOrderLabel': 'Ryd sortering',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Fejl',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Sag',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Sag',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Side',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Historie',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Opgave',
  'fabric.editor.headingLink.invalidLabel': '⚠️ En tabel med flettede celler kan ikke sorteres',
  'fabric.editor.headingLink.noOrderLabel': 'Sortér kolonnen fra A til Å',
  'fabric.editor.help': 'Hjælp',
  'fabric.editor.help.description': 'Se alle tastaturgenveje og Markdown-muligheder',
  'fabric.editor.helpDialogTips': 'Tryk på {keyMap} for at få hurtig adgang til denne dialogboks',
  'fabric.editor.highlight': 'Farve på fremhævning',
  'fabric.editor.highlightColor': 'Slå fremhævningsfarvepalet til/fra',
  'fabric.editor.highlightFloatingToolbar': 'Fremhæv',
  'fabric.editor.horizontalRule': 'Rumdeler',
  'fabric.editor.horizontalRule.description': 'Adskil indhold med en vandret linje',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Indsæt eller søg efter link',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Der vises forslag nedenfor, når du skriver i feltet',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {ingen resultater fundet} one {Der blev fundet {count,number} resultat} other {Der blev fundet {count,number} resultater}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Visningstekst (valgfrit)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Indsæt eller søg efter link',
  'fabric.editor.image': 'Billeder',
  'fabric.editor.image.fullWidthLabel': 'Fuld bredde',
  'fabric.editor.imageBorderBold': 'Fed',
  'fabric.editor.imageBorderColor': 'Farve',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Indstillinger for billedkant Rullemenuen farver',
  'fabric.editor.imageBorderMedium': 'Medium',
  'fabric.editor.imageBorderOptions': 'Kantmuligheder',
  'fabric.editor.imageBorderSize': 'Størrelse',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Indstillinger for billedkant Rullemenuen størrelse',
  'fabric.editor.imageBorderSubtle': 'Diskret',
  'fabric.editor.improvement': 'Forbedring',
  'fabric.editor.increaseElementSize': 'Øg elementstørrelse',
  'fabric.editor.increaseSize': 'Forøg tabel- eller mediestørrelse',
  'fabric.editor.indent': 'Ryk ind',
  'fabric.editor.info': 'Info',
  'fabric.editor.infoPanel': 'Informationspanel',
  'fabric.editor.infoPanel.description': 'Fremhæv information i et farvet panel',
  'fabric.editor.inlineConfigureLink': 'Konfigurer link',
  'fabric.editor.inlineDescription': 'Vis link som indbygget tekst',
  'fabric.editor.inlineGoToLink': 'Gå til link',
  'fabric.editor.inlineOverlay': 'Konfigurer',
  'fabric.editor.inlineTitle': 'Indbyg',
  'fabric.editor.inputQueryAssistiveTxt':
    'Når resultater med automatisk udfyldning er tilgængelige, skal du bruge pil op og pil ned til at gennemse og Enter til at vælge. Brugere af touchenheder kan trykke eller stryge.',
  'fabric.editor.insertColumn': 'Indsæt kolonne til højre',
  'fabric.editor.insertColumnDrag': 'Indsæt kolonne',
  'fabric.editor.insertMenu': 'Indsæt elementer',
  'fabric.editor.insertRightRail.close': 'Luk',
  'fabric.editor.insertRightRail.title': 'Indsæt',
  'fabric.editor.insertRow': 'Indsæt række under',
  'fabric.editor.insertRowDrag': 'Indsæt række',
  'fabric.editor.insertTableColumn': 'Indsæt tabelkolonne',
  'fabric.editor.insertTableRow': 'Indsæt tabelrække',
  'fabric.editor.invalidDateError': 'Indtast en gyldig dato',
  'fabric.editor.invalidLink': 'Indtast et gyldigt link.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Inviter teammedlemmer til {productName}} trusted {Inviter teammedlemmer til {productName}} other {Tilføj teammedlem til {productName}}}',
  'fabric.editor.italic': 'Kursiv',
  'fabric.editor.keyboardShortcuts': 'Tastaturgenveje',
  'fabric.editor.layout.columnOption': '{count, plural, one {Kolonne} other {{count} kolonner}}',
  'fabric.editor.layout.controls.placeholder': '/ for at indsætte',
  'fabric.editor.layout.placeholder': 'Tilføj indhold',
  'fabric.editor.layout.resizeLayout': 'Ændr størrelse på layout',
  'fabric.editor.layoutFixedWidth': 'Tilbage til centrering',
  'fabric.editor.layoutFullWidth': 'Vis i fuld bredde',
  'fabric.editor.layoutStateFixedWidth': 'Centreret',
  'fabric.editor.layoutStateFullWidth': 'Fuld bredde',
  'fabric.editor.layoutStateWide': 'Bredt',
  'fabric.editor.layoutWide': 'Vis bred',
  'fabric.editor.leftSidebar': 'Layout med venstre sidebjælke',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Indsæt et link',
  'fabric.editor.linkAddress': 'Linkadresse',
  'fabric.editor.linkPlaceholder': 'Indsæt link',
  'fabric.editor.lists': 'Liste',
  'fabric.editor.listsFormat': 'Listeformatering',
  'fabric.editor.lockColumns': 'Faste søjlebredder',
  'fabric.editor.longEmptyNodePlaceholderText': 'Skriv / for at indsætte elementer',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Match store/små bogstaver',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Mediebredde reduceret til {newMediaWidth,number} pixel.} other {Mediebredde reduceret til {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Mediebredde øget til {newMediaWidth,number} pixel.} other {Mediebredde øget til {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Medier reduceret til minimumsstørrelsen',
  'fabric.editor.media.insert.cancel': 'Annuller',
  'fabric.editor.media.insert.fileTabTitle': 'Fil',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Vi kan desværre ikke tilføje dette billedlink. Download billedet, og træk og slip det til siden.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Billedet er muligvis ikke synligt for andre på grund af kildebegrænsninger. Du kan prøve at uploade filen i stedet.',
  'fabric.editor.media.insert.insert': 'Indsæt',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Ugyldigt link',
  'fabric.editor.media.insert.linkTabTitle': 'Link',
  'fabric.editor.media.insert.loadPreview': 'Indlæs forhåndsvisning',
  'fabric.editor.media.insert.localFileErrorMessage': 'Filen kunne ikke overføres.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Fejl ved overførsel af fil. Kontrollér filstien eller netværket.',
  'fabric.editor.media.insert.mediaAlt': 'Forhåndsvisning af uploadet billede eller videofil',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Medievælger',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Kopiér og indsæt link for at uploade',
  'fabric.editor.media.insert.upload': 'Upload',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Medier øget til maksimumsstørrelsen',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Tilpas størrelsen',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Luk',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'højdeinput',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Højde',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maks. bredde {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Bredde',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maks. bredde {maxWidth} pixels',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Konverter til pixels',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Overfør fra procentdel til fast pixelstørrelse',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Indsend',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Validering af bredde mislykkedes',
  'fabric.editor.mediaAddLink': 'Tilføj link',
  'fabric.editor.mediaFiles': 'Billede, video eller fil',
  'fabric.editor.mediaFiles.description': 'Tilføj billeder eller andre filer til din side',
  'fabric.editor.mediaGroupDeleteLabel': 'Slet',
  'fabric.editor.media_change_mediainline_caption_warn': 'Indbygget (billedtekst fjernes)',
  'fabric.editor.media_change_mediainline_default': 'Indbyg',
  'fabric.editor.media_change_mediasingle': 'Original størrelse',
  'fabric.editor.mention': 'Benævnelse',
  'fabric.editor.mention.description': 'Omtal nogen for at sende dem en notifikation',
  'fabric.editor.mentionNode.label': 'Tagget bruger',
  'fabric.editor.mentionsAddLabel': 'ikon for tilføj',
  'fabric.editor.mentionsIconLabel': 'Omtal',
  'fabric.editor.mergeCells': 'Flet celler',
  'fabric.editor.moreFormatting': 'Mere formatering',
  'fabric.editor.moveColumnLeft': '{0, plural, one {Flyt kolonne til venstre} other {Flyt kolonner til venstre}}',
  'fabric.editor.moveColumnRight': '{0, plural, one {Flyt kolonne til højre} other {Flyt kolonner til højre}}',
  'fabric.editor.moveDownDown': '{0, plural, one {Flyt række ned} other {Flyt rækker ned}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Flyt række op} other {Flyt rækker op}}',
  'fabric.editor.navigate.toolbar.askAI': 'Spørg AI',
  'fabric.editor.navigate.toolbar.editor': 'Naviger til værktøjslinje til redigeringsprogram',
  'fabric.editor.navigate.toolbar.floating': 'Naviger til flydende værktøjslinje',
  'fabric.editor.noResultsFound': 'Ingen resultater',
  'fabric.editor.noSearchResults': 'Ingen søgeresultater',
  'fabric.editor.normal': 'Normal tekst',
  'fabric.editor.note': 'Note',
  'fabric.editor.notePanel': 'Bemærkningspanel',
  'fabric.editor.notePanel.description': 'Tilføj en note i et farvet panel',
  'fabric.editor.numberedColumn': 'Kolonne med nummerering',
  'fabric.editor.off': '{formattingType} fra',
  'fabric.editor.on': '{formattingType} til',
  'fabric.editor.openButtonTitle': 'Åbn',
  'fabric.editor.openCellOptions': 'Åbn celleegenskaber',
  'fabric.editor.openLink': 'Åbn link i en nye fane',
  'fabric.editor.orderedList': 'Nummereret liste',
  'fabric.editor.orderedList.description': 'Opret en sorteret liste',
  'fabric.editor.other': 'Andet …',
  'fabric.editor.outdent': 'Ryk ud',
  'fabric.editor.overflowMenuViewMore': 'Vis mere',
  'fabric.editor.pageActionsLabel': 'Sidehandlinger',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Baggrundsfarve',
  'fabric.editor.panel.custom': 'Brugerdefineret',
  'fabric.editor.panel.emoji': 'Tilføj emoji',
  'fabric.editor.panel.panelsGroup': 'Paneltyper',
  'fabric.editor.panelButtonTitle': 'Panel',
  'fabric.editor.pasteOptions': 'Indstillinger for indsæt',
  'fabric.editor.pastePlainText': 'Indsæt almindelig tekst',
  'fabric.editor.placeholderAltText': 'Beskriv billedet med alternativ tekst',
  'fabric.editor.placeholderText': 'Midlertidig text',
  'fabric.editor.placeholderText.description': 'Indsæt en pladsholdertekst på siden',
  'fabric.editor.placeholderTextPlaceholder': 'Tilføj midlertidig tekst',
  'fabric.editor.plainText': 'Brug almindelig tekst',
  'fabric.editor.preferencesLink': 'Indstillinger for links',
  'fabric.editor.quickInsert': 'Hurtig indsætning',
  'fabric.editor.recordLoomShortTitle': 'Optag',
  'fabric.editor.recordVideo': 'Optag en Loom-video',
  'fabric.editor.recordVideo.description': 'Optag og del din skærm og dine tanker',
  'fabric.editor.redo': 'Gentag',
  'fabric.editor.remove': 'Fjern',
  'fabric.editor.removeColumns': '{0, plural, one {Slet kolonne} other {Slet kolonner}}',
  'fabric.editor.removeEmoji': 'Fjern emoji',
  'fabric.editor.removeImageBorder': 'Fjern kant',
  'fabric.editor.removeRows': '{0, plural, one {Slet række} other {Slet rækker}}',
  'fabric.editor.replace': 'Erstat',
  'fabric.editor.replaceAll': 'Erstat alle',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} match erstattet} other {{numberOfMatches,number} match erstattet}}',
  'fabric.editor.replaceWith': 'Erstat med',
  'fabric.editor.requestToEdit': 'Anmod om at redigere',
  'fabric.editor.requestToEditDescription': 'Når du anmoder om adgang, modtager sideejeren en notifikation.',
  'fabric.editor.requestToEditDismiss': 'Luk',
  'fabric.editor.resizeHandle': 'Håndtag til størrelsesændring',
  'fabric.editor.resultsCount': '{selectedMatchPosition} af {totalResultsCount}',
  'fabric.editor.richText': 'Brug RTF',
  'fabric.editor.rightSidebar': 'Layout med højre sidebjælke',
  'fabric.editor.rowControl': 'Fremhæv række',
  'fabric.editor.rowDragHandle': 'Rækkeindstillinger',
  'fabric.editor.rowMovedDown': 'Række flyttet ned til {index} af {total}',
  'fabric.editor.rowMovedUp': 'Række flyttet op til {index} af {total}',
  'fabric.editor.rowSelected': 'Række {index} af {total} er valgt',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {En række er blevet indsat} other {{count} rækker er blevet indsat}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Rækken er blevet fjernet} other {{count} rækker er blevet fjernet}}',
  'fabric.editor.saveButton': 'Gem',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} søgeresultat tilgængeligt. Brug piletasterne op og ned til at navigere gennem mulighederne. Tryk på Enter for at vælge en mulighed.} other {{itemsLength,number} søgeresultater er tilgængelige. Brug piletasterne op og ned til at navigere gennem mulighederne. Tryk på Enter for at vælge en mulighed.}}',
  'fabric.editor.selectColumnResize': 'Vælg ændring af kolonnestørrelse',
  'fabric.editor.selectLanguage': 'Vælg sprog',
  'fabric.editor.selectTableColumn': 'Vælg tabelkolonne',
  'fabric.editor.selectTableRow': 'Vælg tabelrække',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Vælg app',
  'fabric.editor.settingsLinks': 'Gå til Indstillinger for links',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ for at indsætte',
  'fabric.editor.shortcut': 'Genvej til tekst',
  'fabric.editor.single': 'Layout med én kolonne',
  'fabric.editor.singleColumns': 'Layout med en kolonne',
  'fabric.editor.sortColumnASC': 'Sorter kolonnen fra A → Å',
  'fabric.editor.sortColumnDESC': 'Sorter kolonnen fra Å → A',
  'fabric.editor.sortColumnDecreasing': 'Sortér faldende',
  'fabric.editor.sortColumnIncreasing': 'Sortér stigende',
  'fabric.editor.splitCell': 'Opdel celle',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Tilføj en brugerdefineret statusetiket',
  'fabric.editor.statusEditorLabel': 'Statusredigeringsprogram',
  'fabric.editor.statusPickerOpenedAlert':
    'Pop op-vinduet til statusredigering er åbnet. Tryk på Tab-tasten for at gå til pop op-vinduet',
  'fabric.editor.statusPlaceholder': 'Angiv en status',
  'fabric.editor.story': 'Historie',
  'fabric.editor.strike': 'Gennemstreget',
  'fabric.editor.subTask': 'Underopgave',
  'fabric.editor.subscript': 'Sænket skrift',
  'fabric.editor.subscript.off.superscript.on': 'Sænket skrift fra, hævet skrift til',
  'fabric.editor.success': 'Succes',
  'fabric.editor.successPanel': 'Succespanel',
  'fabric.editor.successPanel.description': 'Tilføj tip i et farvet panel',
  'fabric.editor.superscript': 'Hævet skrift',
  'fabric.editor.superscript.off.subscript.on': 'Hævet skrift fra, sænket skrift til',
  'fabric.editor.supportAltText': 'Alternativ tekst er nyttig, når folk bruger skærmlæsere pga. synshandicap.',
  'fabric.editor.table': 'Tabel',
  'fabric.editor.table.description': 'Indsæt en tabel',
  'fabric.editor.tableAlignmentOptions': 'Justeringsindstillinger',
  'fabric.editor.tableFullWidthLabel': 'Fuld bredde',
  'fabric.editor.tableHeader.sorting.asc': 'Stigende sortering anvendt',
  'fabric.editor.tableHeader.sorting.default': 'Sortér kolonnen',
  'fabric.editor.tableHeader.sorting.desc': 'Faldende sortering anvendt',
  'fabric.editor.tableHeader.sorting.invalid': 'Du kan ikke sortere en tabel med flettede celler',
  'fabric.editor.tableHeader.sorting.no': 'Ingen sortering anvendt på kolonnen',
  'fabric.editor.tableOptions': 'Egenskaber for tabel',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabelbredde reduceret til {newWidth,number} pixel.} other {Tabelbredde reduceret til {newWidth,number} pixel.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Tabelbredde øget til {newWidth,number} pixel.} other {Tabelbredde øget til {newWidth,number} pixels.}}',
  'fabric.editor.tableScrollRegion': 'Rulleområde i tabel',
  'fabric.editor.tableSelector': 'Tabelstørrelse',
  'fabric.editor.tableSelector.description':
    'Tilføj en tabel ved hjælp af popup for at vælge en brugerdefineret størrelse',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} af {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Vælger til tabelstørrelse',
  'fabric.editor.tables.adjustColumn': 'Tilpas kolonne',
  'fabric.editor.tables.columnResizeLast': 'Du kan kun ændre størrelsen på denne kolonne til venstre.',
  'fabric.editor.tables.columnResizeOverflow':
    'Du kan kun ændre størrelsen på denne kolonne, mens tabellen har en rullebjælke.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Kolonnebredden blev ændret til {width} pixel} other {Kolonnebredden blev ændret til {width} pixels}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Hvis du sletter {nodeName}, brydes forbindelsen til alt, der er forbundet til den.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Slet',
  'fabric.editor.tables.resizeStop': 'Stoppede med at ændre størrelse',
  'fabric.editor.tables.resizeTable': 'Tilpas størrelsen på tabellen',
  'fabric.editor.tables.startedColumnResize': 'Startede med at ændre størrelsen på kolonne',
  'fabric.editor.task': 'Opgave',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Markér opgaven som fuldført',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Markér opgaven som ikke fuldført',
  'fabric.editor.taskPlaceholder': 'Indtast din handling, og brug "@" for at tildele til nogen.',
  'fabric.editor.text.formatting.off': 'Tekstformatering fra',
  'fabric.editor.textColor': '{selectedColorName} tekstfarve',
  'fabric.editor.textColorTooltip': 'Tekstfarve',
  'fabric.editor.textFormat': 'Formatér tekst',
  'fabric.editor.textFormatting': 'Tekstformatering',
  'fabric.editor.textStyles': '{blockTypeName} tekstformatering',
  'fabric.editor.textStylesTooltip': 'Tekstformatering',
  'fabric.editor.threeColumns': 'Layout med tre kolonner',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Layout med tre kolonner med venstre sidebjælke',
  'fabric.editor.threeColumnsWithRightSidebars': 'Layout med tre kolonner med højre sidebjælke',
  'fabric.editor.threeColumnsWithSidebars': 'Layout med tre kolonner med sidebjælker',
  'fabric.editor.time.ago': 'siden',
  'fabric.editor.time.updated': 'Opdateret',
  'fabric.editor.time.viewed': 'Vist',
  'fabric.editor.toolbarAppears': 'Værktøjslinjen vises',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Tilføj billede, video eller fil',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fastgjort øverst',
  'fabric.editor.toolbarPositionInline': 'På linje med tekst',
  'fabric.editor.toolbarPositionPinedAtTop': 'Frigør værktøjslinjen',
  'fabric.editor.toolbarPositionUnpined': 'Fastgør værktøjslinjen foroven',
  'fabric.editor.tooltip.blockPanel': 'et panel',
  'fabric.editor.tooltip.bulletList': 'en liste',
  'fabric.editor.tooltip.decisionList': 'en beslutningsliste',
  'fabric.editor.tooltip.defaultBlockNode': 'en bloknode',
  'fabric.editor.tooltip.nestedExpand': 'en indlejret udvidelse',
  'fabric.editor.tooltip.taskList': 'et handlingselement',
  'fabric.editor.turnInto': 'Skift til',
  'fabric.editor.twoColumns': 'Layout med to kolonner',
  'fabric.editor.typeAhead.popupLabel': 'Resultater for automatisk fuldførelse',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Begynd at skrive for at søge efter eller filtrere genvejsmuligheder',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Søg',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Genveje til indsættelser og formatering',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Der er ingen resultater. Prøv igen.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Noget gik galt',
  'fabric.editor.typeahead.emojiInputLabel': 'Begynd at skrive for at søge efter eller filtrere emojimuligheder',
  'fabric.editor.typeahead.emojiListItemLabel': 'Tekstgenvej {shortcut} til emojien {name}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Emojigenveje',
  'fabric.editor.typeahead.mentionInputLabel': 'Begynd at indtaste for at søge efter brugere, du vil tagge',
  'fabric.editor.typeahead.mentionPopupLabel': 'Brugere, du kan tagge',
  'fabric.editor.typeahead.metionListItemLabel': 'Brugeren {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Vi kunne ikke indlæse dette indhold',
  'fabric.editor.unableToOpenLink': 'Kan ikke åbne dette link',
  'fabric.editor.underline': 'Understreget',
  'fabric.editor.undo': 'Fortryd',
  'fabric.editor.unknown.label': 'Ukendt',
  'fabric.editor.unlink': 'Fjern link',
  'fabric.editor.unorderedList': 'Punktopstilling',
  'fabric.editor.unorderedList.description': 'Opret en ikke-sorteret liste',
  'fabric.editor.unsupportedBlockContent': 'Denne editor understøtter ikke visning af dette indhold',
  'fabric.editor.unsupportedContentTooltip':
    'Indholdet er ikke tilgængeligt i denne editor. Det bevares, når du redigerer og gemmer',
  'fabric.editor.unsupportedInlineContent': 'Ikke-understøttet indhold',
  'fabric.editor.upDown': 'Når du bruger piletasterne op og ned i følgende indtastningsfelt opdateres datoen nedenfor',
  'fabric.editor.url': 'Visnings-URL',
  'fabric.editor.urlDescription': 'Vis link som URL-adresse',
  'fabric.editor.urlTitle': 'URL-adresse',
  'fabric.editor.useMarkdown': 'Brug markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Se og tilføj kommentarer',
  'fabric.editor.viewCommentOnMedia': 'Se kommentarer',
  'fabric.editor.viewMore': 'Vis mere',
  'fabric.editor.viewMoreAriaLabel': 'Vis alle elementer',
  'fabric.editor.visit': 'Åbn link i et nyt vindue',
  'fabric.editor.warning': 'Advarsel',
  'fabric.editor.warningPanel': 'Advarselspanel',
  'fabric.editor.warningPanel.description': 'Tilføj en advarselsnote i et farvet panel',
  'fabric.editor.wrapLeft': 'Skub til venstre',
  'fabric.editor.wrapRight': 'Skub til højre',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Blå',
  'fabric.theme.bold-blue': 'Stærk blå',
  'fabric.theme.bold-gray': 'Stærk grå',
  'fabric.theme.bold-green': 'Stærk grøn',
  'fabric.theme.bold-magenta': 'Stærk magenta',
  'fabric.theme.bold-orange': 'Stærk orange',
  'fabric.theme.bold-purple': 'Stærk lilla',
  'fabric.theme.bold-red': 'Stærk rød',
  'fabric.theme.bold-teal': 'Stærk turkis',
  'fabric.theme.bold-yellow': 'Stærk gul',
  'fabric.theme.bolder-blue': 'Stærkere blå',
  'fabric.theme.bolder-gray': 'Stærkere grå',
  'fabric.theme.bolder-green': 'Stærkere grøn',
  'fabric.theme.bolder-magenta': 'Stærkere magenta',
  'fabric.theme.bolder-orange': 'Stærkere orange',
  'fabric.theme.bolder-purple': 'Stærkere lilla',
  'fabric.theme.bolder-red': 'Stærkere rød',
  'fabric.theme.bolder-teal': 'Stærkere turkis',
  'fabric.theme.bolder-yellow': 'Stærkere gul',
  'fabric.theme.dark-blue': 'Mørk blå',
  'fabric.theme.dark-gray': 'Mørk grå',
  'fabric.theme.dark-green': 'Mørk grøn',
  'fabric.theme.dark-purple': 'Mørk lilla',
  'fabric.theme.dark-red': 'Mørk rød',
  'fabric.theme.dark-teal': 'Mørk teal',
  'fabric.theme.dark-yellow': 'Mørk gul',
  'fabric.theme.default': 'Standard',
  'fabric.theme.gray': 'Grå',
  'fabric.theme.green': 'Grøn',
  'fabric.theme.light-blue': 'Lys blå',
  'fabric.theme.light-gray': 'Lys grå',
  'fabric.theme.light-green': 'Lys grøn',
  'fabric.theme.light-purple': 'Lys lilla',
  'fabric.theme.light-red': 'Lys rød',
  'fabric.theme.light-teal': 'Lys teal',
  'fabric.theme.light-yellow': 'Lys gul',
  'fabric.theme.lime': 'Limegrøn',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Ingen fremhævning',
  'fabric.theme.orange': 'Orange',
  'fabric.theme.purple': 'lilla',
  'fabric.theme.red': 'Rød',
  'fabric.theme.subtle-blue': 'Svag blå',
  'fabric.theme.subtle-gray': 'Svag grå',
  'fabric.theme.subtle-green': 'Svag grøn',
  'fabric.theme.subtle-magenta': 'Svag magenta',
  'fabric.theme.subtle-orange': 'Svag orange',
  'fabric.theme.subtle-purple': 'Svag lilla',
  'fabric.theme.subtle-red': 'Svag rød',
  'fabric.theme.subtle-teal': 'Svag turkis',
  'fabric.theme.subtle-yellow': 'Svag gul',
  'fabric.theme.teal': 'Teal',
  'fabric.theme.white': 'Hvid',
  'fabric.theme.yellow': 'Gul',
  'fabrid.editor.rowNumbers': 'Rækkenumre',
  'rovo.agents.dropdown.title': 'Agenter',
  'rovo.agents.dropdown.viewAgents.label': 'Vis alle agenter',
};
